<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.231"
    height="15.351"
    viewBox="0 0 13.231 15.351">
    <g id="download" transform="translate(-3.499 -2)">
      <path
        id="Path_487"
        data-name="Path 487"
        d="M12.159,2.762H7.142A2.881,2.881,0,0,0,4.251,5.574v8.1A2.871,2.871,0,0,0,7.059,16.6h6.108a2.917,2.917,0,0,0,2.813-2.932V6.741Z"
        transform="translate(0 -0.003)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        fill-rule="evenodd" />
      <path
        id="Path_488"
        data-name="Path 488"
        d="M14.475,2.75V4.944a1.942,1.942,0,0,0,1.938,1.942H18.49"
        transform="translate(-2.513)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
      <path
        id="Path_489"
        data-name="Path 489"
        d="M11.642,14.465V9.909"
        transform="translate(-1.816 -1.76)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
      <path
        id="Path_490"
        data-name="Path 490"
        d="M9.3,13.594l1.769,1.776,1.769-1.776"
        transform="translate(-1.24 -2.666)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
    </g>
  </svg>
</template>
